import { isToday } from 'date-fns';
import format from 'date-fns/format';
import isTomorrow from 'date-fns/isTomorrow';
import ru from 'date-fns/locale/ru';

export const formatDeliveryDate = (unixTimestamp: number) => {
    const date = new Date(unixTimestamp * 1000);

    if (isToday(date)) {
        return 'Сегодня';
    }

    if (isTomorrow(date)) {
        return 'Завтра или позже';
    }

    return format(date, 'd MMMM', { locale: ru });
};
